import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
//import { WebTableData } from '../packageupload/packageupload.component';
import { logbaseService } from '../../services/logbase.service';

export interface WebTableData {
  fileType: string;
  fileName: string;
  status: string;
  uploadedBy: string;
  uploadedDate: any;
}

@Component({
  selector: 'app-parts-upload',
  templateUrl: './parts-upload.component.html',
  styleUrls: ['./parts-upload.component.scss']
})
export class PartsUploadComponent implements OnInit {
  @ViewChild('partsUpload') partsUpload: ElementRef;
  tablePartsSource: WebTableData[] = [];
  file: File= null;
  constructor(private fb: FormBuilder, private cd: ChangeDetectorRef, private logbaseService: logbaseService,
    private spinner: NgxSpinnerService) { }

  ngOnInit() {
    this.getUploadedDetails();
  }
  onFileChange(event) {
    this.file = event.target.files[0];
  }
  getUploadedDetails() {
    this.logbaseService.getFilesData('package').subscribe( result => {
      console.log(result);
      this.tablePartsSource = result.response;
    });
  }
  onPartsUpload() {

    var currentUser = JSON.parse(localStorage.getItem('currentUser'));
    const formdata = new FormData();
    formdata.append('partsFile', this.file);

    this.spinner.show();
    var responseArray: any = [];
    
    this.logbaseService.partsUploadData(formdata, currentUser).subscribe(result => {
      var responseData = result;
      responseArray = responseData.response;
      responseArray.forEach(response => {
        var tempResponseHolder: any = response;
        this.tablePartsSource.push({
          fileType: tempResponseHolder.fileType,
          fileName: tempResponseHolder.fileName,
          status: tempResponseHolder.status,
          uploadedBy: tempResponseHolder.uploadedBy,
          uploadedDate: tempResponseHolder.uploadedDate,
        });
      });
      console.log(JSON.stringify(this.tablePartsSource));
      this.spinner.hide();
    });
    this.reset();
  }
  reset() {
    console.log(this.partsUpload.nativeElement.files);
    this.partsUpload.nativeElement.value = '';
    console.log(this.partsUpload.nativeElement.files);
  }
}
